import { createClient } from "@supabase/supabase-js";

// Get environment variables
let supabaseUrl: string;
let supabaseAnonKey: string;

// In browser environments, use import.meta.env
if (typeof window !== "undefined") {
  console.log("🔍 Browser environment detected, using import.meta.env");
  supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string) || "";
  supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || "";
}
// In Node.js environments, use process.env
else if (typeof process !== "undefined" && process.env) {
  console.log("🔍 Node.js environment detected, using process.env");
  supabaseUrl = (process.env.VITE_SUPABASE_URL as string) || "";
  supabaseAnonKey = (process.env.VITE_SUPABASE_ANON_KEY as string) || "";
}
// Fallback
else {
  console.log("🔍 Could not detect environment, using fallback");
  supabaseUrl = "";
  supabaseAnonKey = "";
}

console.log("🔍 Supabase URL:", supabaseUrl);
console.log("🔍 Supabase Key exists:", !!supabaseAnonKey);

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing Supabase environment variables. Please check your .env file."
  );
}

// Create Supabase client with strict configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: "sb-auth-token",
    detectSessionInUrl: true,
    flowType: "pkce",
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export async function getEnvironmentVariable(
  key: string
): Promise<string | null> {
  console.log(`🔍 Attempting to retrieve environment variable: ${key}`);
  try {
    const { data, error } = await supabase
      .from("env_vars")
      .select("value")
      .eq("key", key)
      .maybeSingle();

    console.log(`🔍 Query result for ${key}:`, {
      hasData: !!data,
      hasError: !!error,
      errorCode: error?.code,
      errorMessage: error?.message,
    });

    if (error || !data) {
      if (error?.code === "PGRST116") {
        console.error(`🔍 Environment variable not found: ${key}`);
        return null;
      }
      console.error("🔍 Error fetching environment variable:", {
        key,
        error: error || "No data found",
      });
      return null;
    }

    console.log(`🔍 Successfully retrieved value for ${key}`);
    return data.value;
  } catch (error) {
    console.error("🔍 Error in getEnvironmentVariable:", error);
    return null;
  }
}
